





























import { mapGetters } from 'vuex';

import { getMediaTypeIconClasses } from '@/core/utils/media';
import {
  formatVideoLengthFromSeconds,
  getDefaultThumbnailForMediaType,
} from '@/web/utils/media';

export default {
  name: 'MediaThumbnail',
  props: {
    media: {
      type: Object as () => ProductMediaResponse,
      required: false,
    },
    hideOverlay: {
      type: Boolean,
      default: false,
    },
    mediaTypeOverride: {
      type: String,
    },
    isLocked: {
      type: Boolean,
      default: false,
    },
    mediaIconsEnabled: {
      type: Boolean,
      default: true,
    },
    mediaTimeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      canViewProductContent: 'product/canViewProductContent',
    }),
    duration() {
      const videoLength = this.media?.media?.video_length;
      if (!videoLength) return null;
      return formatVideoLengthFromSeconds(videoLength);
    },
    getMediaTypeIcon() {
      if (!this.media) return '';
      return getMediaTypeIconClasses(this.media?.media?.file_content);
    },
    style(): object | null {
      const thumbnailUrl =
        this.media?.media?.thumbnail ||
        getDefaultThumbnailForMediaType(
          this.media?.media?.file_content || this.mediaTypeOverride
        );
      return {
        backgroundImage: 'url(' + thumbnailUrl + ')',
        backgroundSize: 'cover',
      };
    },
  },
  methods: {},
};
